import { View } from "react-native";
import { AHIcon } from "arkh/src/cross-platform/AHIcon";
import { Box } from "arkh/src/cross-platform/AHTheme/Box";
import { AHSeparator } from "arkh";

export function TodoToolbarContainer(props: {
  locked?: React.ReactNode;
  editable?: React.ReactNode;
}) {
  return (
    <Box
      borderColor="border-primary"
      style={{ borderWidth: 1 }}
      color="surface"
      cornerRadius="large"
    >
      {props.locked ? (
        <Box
          style={{ flexDirection: "row", flexWrap: "wrap" }}
          gap="small"
          space="medium"
        >
          {props.locked}
          <View
            style={{
              position: "absolute",
              right: 0,
              top: 0,
              bottom: 0,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AHIcon
              spaceRight="medium"
              type="locked"
              size="xsmall"
              color="text-washed"
            />
          </View>
        </Box>
      ) : null}
      {props.editable && props.locked ? <AHSeparator /> : null}
      {props.editable ? (
        <Box
          style={{ flexDirection: "row", flexWrap: "wrap" }}
          gap="small"
          space="medium"
        >
          {props.editable}
        </Box>
      ) : null}
    </Box>
  );
}
